import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 5,
	viewBox: "0 0 5 5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 2.5,
		cy: 2.5,
		r: 2.5,
		fill: "#00ABFF"
	})
});
export default SvgIconCircle;
